import { Injectable } from '@angular/core';

import { EmailComposer } from '@awesome-cordova-plugins/email-composer/ngx';
import { TranslateService } from '@jht/brand-translate';

import { EmailService } from './email.service';
import { FileService } from '../file.service';
import { PlatformService } from '../platform.service';
import {
    LINE_BREAK_BROWSER,
    LINE_BREAK_NATIVE,
} from './config';
import { mediaDirectory } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class EmailImageService extends EmailService {
    constructor(
        protected emailComposer: EmailComposer,
        protected platformService: PlatformService,
        protected fileService: FileService,
        protected translationService: TranslateService
    ) {
        super(emailComposer, platformService, fileService);
    }

    getDefaultBody(imageFileName: string, isColorConfig?: boolean) {
        // Email body needs to be html for LINE_BREAK_NATIVE to work
        const lineBreak = this.platformService.isBrowser
            ? LINE_BREAK_BROWSER
            : LINE_BREAK_NATIVE;
        const directory = isColorConfig
            ? ''
            : mediaDirectory.externalMedia;
        const imageLink = directory + imageFileName;
        const bodyTemplate = this.translationService.instant('GLOBAL_EMAIL_TEXT')
            .replace('{{linebreaks}}', `${lineBreak}${lineBreak}`)
            .replace('{{link}}', imageLink);
        return bodyTemplate;
    }
}
